import { APIBase } from "./@base.api";

export class ContactApi extends APIBase {
  /**
   *
   */
  constructor(context) {
    super(context);
    this.endPoints = {
      getAll: "Contact/GetAll",
      getAllSP: "Contact/GetAllSP",
      insertEndUser: "Contact/InsertEndUser",
      updateEndUser: "Contact/UpdateEndUser",
      setAllowLogin: "Contact/SetAllowLogin",
      getEndUser: "Contact/GetEndUser",
      insert: "Contact/Insert",
      update: "Contact/Update",
      delete: "Contact/Delete",
      get: "Contact/Get",
      addSalesPerson: "Contact/AddSalesPerson",
      getShirtUsers: "Contact/GetShirtUsers",
      getDropdownItems: "Contact/GetDropdownItems",
      getEditOrderShirtUsers: "Contact/GetEditOrderShirtUsers",
    };
  }

  /**
   * 
   * @param {*} data 
   * @returns 
   */
  insertEndUser = data => this.httpPost(this.endPoints.insertEndUser, data);

  /**
   * 
   * @param {*} data 
   * @returns 
   */
  updateEndUser = data => this.httpPost(this.endPoints.updateEndUser, data);

  /**
   * 
   * @param {*} data 
   * @returns 
   */
  setAllowLogin = data => this.httpPost(this.endPoints.setAllowLogin, data);

  /**
   *
   * @returns
   */
  getEndUser = id => this.httpGet(`${this.endPoints.getEndUser}?id=${id}`);

  /**
   * 
   * @returns 
   */
  addSalesPerson = obj => this.httpPost(this.endPoints.addSalesPerson, obj);
  
  /**
   * 
   * @returns 
   */
  getEditOrderShirtUsers = () => this.httpGet(this.endPoints.getEditOrderShirtUsers);

  /**
   * 
   * @returns 
   */
  getDropdownItems = () => this.httpGet(this.endPoints.getDropdownItems);

  /**
   * 
   * @returns 
   */
  getShirtUsers = () => this.httpGet(this.endPoints.getShirtUsers);

  /**
   *
   * @returns
   */
  getAllSP = () => this.httpGet(this.endPoints.getAllSP);
}
